import { render, staticRenderFns } from "./beneficiary-list.vue?vue&type=template&id=640fa6f6"
import script from "./beneficiary-list.vue?vue&type=script&lang=js"
export * from "./beneficiary-list.vue?vue&type=script&lang=js"
import style0 from "./beneficiary-list.vue?vue&type=style&index=0&id=640fa6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports